import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { Mail, Save } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";

interface SharedWorkflowSettingsProps {
  emailValue: string;
  onEmailChange: (value: string) => void;
  onEmailSave: () => void;
  surveillanceEnabled: boolean;
  onSurveillanceChange: (checked: boolean) => void;
  notificationsEnabled: boolean;
  isUpdating: boolean;
  canEdit: boolean;
}

// Legacy notification fields shown inside the Notifications card while the
// camera still sends alerts through BuildShip (app alerts switched off).
export const SharedWorkflowSettings = ({
  emailValue,
  onEmailChange,
  onEmailSave,
  surveillanceEnabled,
  onSurveillanceChange,
  notificationsEnabled,
  isUpdating,
  canEdit,
}: SharedWorkflowSettingsProps) => {
  const isMobile = useIsMobile();

  return (
    <div className="space-y-4">
      <div className={`grid gap-4 ${isMobile ? 'grid-cols-1' : 'grid-cols-2'}`}>
        {/* Notification Email */}
        <div className="space-y-1.5">
          <div className="flex items-center gap-2">
            <Mail className="h-4 w-4 text-brand-500" />
            <Label className="text-sm font-medium">Notification Email</Label>
          </div>
          <div className="flex gap-2">
            <Input
              type="email"
              value={emailValue}
              onChange={(e) => onEmailChange(e.target.value)}
              disabled={isUpdating || !canEdit}
              className="h-9"
              placeholder="Enter email address"
            />
            <Button variant="outline" size="sm" onClick={onEmailSave} disabled={isUpdating || !canEdit} className="h-9 bg-component-background text-foreground border border-foreground">
              <Save className="h-4 w-4" />
            </Button>
          </div>
          <p className="text-xs text-muted-foreground">Separate multiple emails with commas</p>
        </div>

        {/* Email all images */}
        <div className="space-y-3">
          <div className="flex items-center justify-end gap-3">
            <Switch checked={surveillanceEnabled} onCheckedChange={onSurveillanceChange} disabled={isUpdating || !canEdit || !notificationsEnabled} />
            <div className="space-y-0.5">
              <Label className="text-sm">Email All Images</Label>
              <p className="text-xs text-muted-foreground">Email alert for every photo</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
